import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
function getButtonColorClass(color) {
    switch (color) {
        case 'blue':
            return 'text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300';
        case 'green':
            return 'text-white bg-green-700 hover:bg-green-800 focus:ring-green-300';
        case 'red':
            return 'text-white bg-red-700 hover:bg-red-800 focus:ring-red-300';
        case 'light':
            return 'text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 focus:ring-gray-200';
        case 'dark':
            return 'text-white bg-gray-800 hover:bg-gray-900 focus:ring-gray-300';
        case 'white':
            return 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-blue-500';
        default:
            throw new Error(`Unknown button color: ${color}`);
    }
}
function getButtonSizeClass(size) {
    switch (size) {
        case 'small':
            return 'px-3 py-2 text-sm';
        case 'base':
            return 'px-5 py-2.5 text-sm';
        case 'large':
            return 'px-5 py-3 text-base';
        default:
            throw new Error(`Unknown button size: ${size}`);
    }
}
export function Button(props) {
    const { className, children, disabled, size = 'base', color = 'blue', type = 'button', onClick, icon, iconPosition = 'left', } = props;
    return (_jsx("button", { className: clsx('rounded-lg text-center font-medium focus:outline-none focus:ring-4 disabled:cursor-not-allowed disabled:bg-opacity-50', getButtonColorClass(color), getButtonSizeClass(size), className), disabled: disabled, onClick: onClick, 
        // a type is being provided but eslint doesn't know
        // eslint-disable-next-line react/button-has-type
        type: type, children: icon ? (_jsxs("div", { className: "flex flex-row items-center space-x-2", children: [iconPosition === 'left' && icon, _jsx("div", { children: children }), iconPosition === 'right' && icon] })) : (children) }));
}
